import type { RuleHandler } from "../types";

const checkExcludePromotionalMarkets: RuleHandler = (context, requirement) => {
  if (
    requirement.userDrivenAttributes?.excludePromotionalMarkets &&
    context.selection.hasPromotionalMarkets
  ) {
    return false;
  }

  return true;
};

export { checkExcludePromotionalMarkets };
